"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleButtonWithMaybePrompt = exports.StyleButton = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var className = "style-button";
var StyleButton = (function (_super) {
    __extends(StyleButton, _super);
    function StyleButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StyleButton.prototype.render = function () {
        var _a, _b;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className, "top-button-inner", "center", (_a = {},
                _a["".concat(className, "--with-side-action")] = this.props.shouldShowShortcut,
                _a)) },
            this.props.shouldShowShortcut && (react_1.default.createElement(kaleidoscope_1.Tooltip, { content: "Block style" },
                react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(className, "__icon"), "".concat(className, "__icon--start"), "".concat(className, "__icon--block-style"), "center"), onClick: this.props.onShortcutClick },
                    react_1.default.createElement(icons_1.Styles, null)))),
            react_1.default.createElement(kaleidoscope_1.Tooltip, { content: "Style library" },
                react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(className, "__icon"), "".concat(className, "__icon--end"), "".concat(className, "__icon--style-library"), "center", (_b = {},
                        _b["".concat(className, "__icon--single-action")] = !this.props.shouldShowShortcut,
                        _b)), onClick: this.props.onLibraryClick },
                    react_1.default.createElement(icons_1.StylesLibrary, null)))));
    };
    StyleButton = __decorate([
        mobx_react_1.observer
    ], StyleButton);
    return StyleButton;
}(react_1.default.Component));
exports.StyleButton = StyleButton;
var StyleButtonWithMaybePrompt = (function (_super) {
    __extends(StyleButtonWithMaybePrompt, _super);
    function StyleButtonWithMaybePrompt() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StyleButtonWithMaybePrompt.prototype.render = function () {
        if (this.props.isFirstBlock) {
            return (react_1.default.createElement("div", null,
                react_1.default.createElement(StyleButton, __assign({}, this.props))));
        }
        else {
            return react_1.default.createElement(StyleButton, __assign({}, this.props));
        }
    };
    StyleButtonWithMaybePrompt = __decorate([
        mobx_react_1.observer
    ], StyleButtonWithMaybePrompt);
    return StyleButtonWithMaybePrompt;
}(react_1.default.Component));
exports.StyleButtonWithMaybePrompt = StyleButtonWithMaybePrompt;
exports.default = (function (mountReactComponent, styleButtonStore, onLibraryClick, onShortcutClick, isFirstBlock, rootDataStore) {
    return mountReactComponent(react_1.default.createElement(StyleButtonWithMaybePrompt, { shouldShowShortcut: styleButtonStore.shouldShowShortcut, onLibraryClick: function (event) {
            onLibraryClick(event);
        }, onShortcutClick: function (event) {
            onShortcutClick(event);
        }, isFirstBlock: isFirstBlock }));
});
